import {
  addCurrentAuthHeader,
  type SessionService,
} from '@efdigital/ll-addon-auth';
import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import type {
  CoachMatch,
  CohortCoachMatchesResponseBody,
} from '@efdigital/ll-cdk-coaching-ai-matching-api-types';

export async function buildCoachMatchesRequest(
  apis: Apis,
  session: SessionService,
  cohortId: string
) {
  const init = await addCurrentAuthHeader(
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    { session }
  );

  return new Request(
    `${apis.systemsApi.host}/ll-coaching-ai-matching/coachee/cohorts/${encodeURIComponent(cohortId)}/coach-matches`,
    init
  );
}

export async function parseCoachMatchesResponse(
  response: Response
): Promise<CoachMatch[]> {
  if (!response.ok) {
    const body = await response.text();
    console.error('[coach-matches] request failed', response.status, body);
    throw new Error(
      `Failed to fetch coach matches: ${response.status} ${body}`
    );
  }

  const data = (await response.json()) as CohortCoachMatchesResponseBody;
  return data;
}
